export const SIMPLE_GRID_ORDER_ASC = 'asc';
export type SIMPLE_GRID_ORDER_ASC = 'asc';
export const SIMPLE_GRID_ORDER_DESC = 'desc';
export type SIMPLE_GRID_ORDER_DESC = 'desc';
export type SimpleGridOrder = SIMPLE_GRID_ORDER_ASC | SIMPLE_GRID_ORDER_DESC;